// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelect_select__1gvm4","error-message":"CustomSelect_error-message__3chny"};